import React from 'react';
import { Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ExitAuthorizationForm from '../components/ExitAuthorizationForm';

const CreateExitAuthPage = () => {
  const navigate = useNavigate();
  
  const handleClose = () => {
    navigate('/exit-authorizations');
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Créer une nouvelle autorisation de sortie
      </Typography>
      
      <ExitAuthorizationForm open={true} onClose={handleClose} />
    </Container>
  );
};

export default CreateExitAuthPage;
